import { render, staticRenderFns } from "./driverDiag.vue?vue&type=template&id=584c7498&scoped=true"
import script from "./driverDiag.vue?vue&type=script&lang=js"
export * from "./driverDiag.vue?vue&type=script&lang=js"
import style0 from "./driverDiag.vue?vue&type=style&index=0&id=584c7498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c7498",
  null
  
)

export default component.exports